import { useLocale } from './useLocale';
import type { Locale } from './index';

// `compact` = a small, chrome-light select (2-letter code) for tight mobile headers.
const SHORT: Record<string, string> = { ru: 'RU', en: 'EN', ky: 'KG', kk: 'KZ', uz: 'UZ', tr: 'TR' };

export function LanguageSwitcher({ compact }: { compact?: boolean }) {
  const { locale, setLocale, locales, label } = useLocale();
  if (compact) {
    return (
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value as Locale)}
        aria-label="Language"
        style={{
          fontFamily: 'inherit', fontSize: 12.5, fontWeight: 600, color: '#cdd',
          background: 'transparent', border: '1px solid rgba(255,255,255,0.18)',
          borderRadius: 8, padding: '5px 7px', cursor: 'pointer', appearance: 'none',
        }}
      >
        {locales.map((l) => <option key={l} value={l} style={{ color: '#000' }}>{SHORT[l] ?? l.toUpperCase()}</option>)}
      </select>
    );
  }
  return (
    <select value={locale} onChange={(e) => setLocale(e.target.value as Locale)} aria-label="Language">
      {locales.map((l) => <option key={l} value={l}>{label[l]}</option>)}
    </select>
  );
}
